import React from "react";
import { useHistory } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";

import {
  StyledConnectionLogo,
  StyledConnectionName,
  StyledConnectionWrapper
} from "../../../elements/connection/styledConnection";

const SuperAdminConnection = ({ userId, userService }) => {

  const {
    id,
    name,
    nickname
  } = userService;

  const history = useHistory();

  const handleClick = () => {
    history.push("/connections/" + userId + "/" + id);
  };

  return (
    <>
      <StyledConnectionWrapper className="connection" onClick={handleClick}>
        <StyledConnectionLogo
          icon={name}
          className="connection__tag"
        />
        <StyledConnectionName className="connection__name">
          {getServiceNameWithNickname(name, nickname)}
        </StyledConnectionName>
      </StyledConnectionWrapper>
    </>
  );
};

export default SuperAdminConnection;